export const REFERRALS_TAG_TYPE = 'Referrals' as const;
export const REFERRALS_INBOUND_ID = 'INBOUND' as const;
export const REFERRALS_OUTBOUND_ID = 'OUTBOUND' as const;
